// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PZJjx","newExpiryDate":"styles_newExpiryDate__2mONy","footer":"styles_footer__3b4He"};